import React from 'react';
import { compose } from 'redux';
import { Link, withRouter } from 'react-router-dom'
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const styles = theme => ({
  icon: {
    color: '#1e1f20',
  },
  iconSelected: {
    color: '#daac57',
  },
  itemText: {
    color: '#000000',
    opacity: '0.6',
  },
  itemTextSelected: {
    color: '#1e1f20',
    fontWeight: 500,
  },
  root: {
    '&$selected': {
      backgroundColor: '#fdf8ec',
      '&:focus': {
        backgroundColor: '#fdf8ec',
      },
      '&:hover': {
        backgroundColor: '#fdf8ec',
      },
    },
    '&:hover': {
      backgroundColor: '#fdf8ec',
    },
  },
  selected: {},
});

class ListItemComponent extends React.Component {
  renderLink = itemProps => <Link to={this.props.to} {...itemProps} />;

  render() {
    const { classes, icon, primary, selected } = this.props;

    return (
      <li>
        <ListItem classes={{ root: classes.root, selected: classes.selected }} selected={selected} button component={this.renderLink}>
          <ListItemIcon className={classNames(selected ? classes.iconSelected : classes.icon)}>{icon}</ListItemIcon>
          <ListItemText className={classNames(selected ? classes.itemTextSelected : classes.itemText)} primary={primary} />
        </ListItem>
      </li>
    );
  }
}

ListItemComponent.propTypes = {
  icon: PropTypes.node.isRequired,
  primary: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
};

export default compose(withRouter, withStyles(styles))(ListItemComponent);
